import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@icon/task-check-list.svg'
import _imports_1 from '@icon/dots-horizontal-bottom.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "task__drag-handle" }, null, -1)
const _hoisted_2 = { class: "task__inner" }
const _hoisted_3 = { class: "task__name custom-outline" }
const _hoisted_4 = ["id", "value", "readonly"]
const _hoisted_5 = ["title"]
const _hoisted_6 = {
  key: 3,
  class: "error-text error-text-small is-left"
}
const _hoisted_7 = {
  key: 4,
  class: "error-text error-text-small is-left"
}
const _hoisted_8 = ["id"]
const _hoisted_9 = {
  key: 0,
  class: "searchQuery"
}
const _hoisted_10 = { class: "searchQuery-clue" }
const _hoisted_11 = ["id", "value", "readonly"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_icon = _resolveComponent("icon")!
  const _component_ExpectedDeliveryIndicator = _resolveComponent("ExpectedDeliveryIndicator")!
  const _component_DropdownBasic = _resolveComponent("DropdownBasic")!
  const _component_AvatarSelect = _resolveComponent("AvatarSelect")!
  const _component_TaskMoveTo = _resolveComponent("TaskMoveTo")!
  const _component_DropdownTooltip = _resolveComponent("DropdownTooltip")!
  const _component_BaseCaption = _resolveComponent("BaseCaption")!
  const _directive_focus = _resolveDirective("focus")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["task", { 'is-new': _ctx.isNewTask, 'is-read-only': _ctx.task.readOnly }])
  }, [
    _hoisted_1,
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createVNode(_component_BaseSubHeading, {
        class: "task__number",
        weight: "400",
        size: "medium",
        color: "monochrome-05",
        darkColor: "monochrome-04"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.task.order), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          id: `name_${_ctx.index}`,
          ref: "nameInput",
          value: _ctx.task.name,
          type: "text",
          placeholder: "Enter Task Name",
          autocomplete: "off",
          class: _normalizeClass(["task__input", { 'pointer-none': _ctx.dragItem }]),
          readonly: _ctx.isReadonly,
          onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleNameInput($event))),
          onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.enter($event)), ["enter"])),
          onFocusin: _cache[2] || (_cache[2] = ($event: any) => (_ctx.focusIn(`name_${_ctx.index}`))),
          onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
        }, null, 42, _hoisted_4), [
          [_directive_focus, !_ctx.isOpen ? _ctx.isActive(`name_${_ctx.index}`) : false],
          [_directive_tooltip, {
            content: _ctx.task.name,
            theme: 'info-tooltip',
            placement: 'bottom',
            popperClass: 'story__title__tooltip',
            skidding: 24,
            disabled: !_ctx.showTooltipName
          }]
        ]),
        (_ctx.showChecklistIndicator)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "task__checklist-indicator",
              type: "button",
              title: _ctx.task.checklistFullyChecked ? 'Checklist complete' : 'Unchecked checklist items',
              onMousedown: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.checkSelectedTask && _ctx.checkSelectedTask(...args)))
            }, [
              _createVNode(_component_icon, {
                data: _imports_0,
                width: "var(--icon-24)",
                class: "common-gray-interactive",
                height: "var(--icon-24)"
              })
            ], 40, _hoisted_5))
          : _createCommentVNode("", true),
        (_ctx.taskNameLength && _ctx.showAddDescriptionButton && !_ctx.showChecklistIndicator)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: _normalizeClass(["task__add-description", {
            'task__add-description_visible': _ctx.addDescriptionButton,
            'task__add-description_hidden': _ctx.isOpen
          }]),
              tabindex: "-1",
              type: "button",
              onMousedown: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.checkSelectedTask && _ctx.checkSelectedTask(...args)))
            }, [
              _createVNode(_component_icon, {
                data: _imports_1,
                fill: true,
                color: "#336DFF",
                width: "24",
                height: "24"
              })
            ], 34))
          : _createCommentVNode("", true),
        (_ctx.showExpectedDeliveryIndicator)
          ? (_openBlock(), _createBlock(_component_ExpectedDeliveryIndicator, {
              key: 2,
              class: "task__delivery-date-indicator",
              hasExpectedDeliveryDate: _ctx.task.hasExpectedDeliveryDate,
              formattedExpectedDeliveryDate: _ctx.task.formattedExpectedDeliveryDate,
              isExpectedDeliveryDateOverdue: _ctx.task.isExpectedDeliveryDateOverdue,
              iconSize: "var(--icon-24)",
              onMousedown: _ctx.checkSelectedTask
            }, null, 8, ["hasExpectedDeliveryDate", "formattedExpectedDeliveryDate", "isExpectedDeliveryDateOverdue", "onMousedown"]))
          : _createCommentVNode("", true),
        (_ctx.cannotBeDeleted && !_ctx.isNewTask)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, " Unable to delete a Task. At least one task must exist in an Item "))
          : _createCommentVNode("", true),
        (_ctx.showNameRequiredError)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, " Task Name is required "))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.isNewTask)
        ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 0,
            id: `type_${_ctx.index}`,
            class: _normalizeClass(["task_focus", { 'is-disabled': _ctx.isTaskTypeReadonly || _ctx.isReadonly }]),
            type: "button",
            tabindex: "-1"
          }, [
            _createVNode(_component_DropdownBasic, {
              id: `typeParsed_${_ctx.index}`,
              value: _ctx.taskType,
              options: _ctx.availableTaskTypes,
              index: _ctx.index,
              hideSelected: false,
              placeholder: _ctx.placeholderForType,
              trackBy: "id",
              tabindex: -1,
              label: "label",
              class: _normalizeClass(["task__type custom-outline dropdown-basic", [
            { viewPlaceholder: !_ctx.searchQuery, task__type_disable: !_ctx.taskNameLength },
            { 'pointer-none': _ctx.isReadonly }
          ]]),
              noResult: "No elements found.",
              appendDropDownToBody: true,
              onOnSelect: _ctx.onSelectType,
              onCheckOpenDropdown: _ctx.checkOpenDropdown,
              onDropdownInput: _ctx.dropdownInput,
              onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
            }, null, 8, ["id", "value", "options", "index", "placeholder", "class", "onOnSelect", "onCheckOpenDropdown", "onDropdownInput"]),
            (!_ctx.searchQuery)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createTextVNode(_toDisplayString(_ctx.dropdownSearch), 1),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.dropdownSearchClue), 1)
                ]))
              : _createCommentVNode("", true)
          ], 10, _hoisted_8)), [
            [_directive_focus, _ctx.isActive(`type_${_ctx.index}`)]
          ])
        : _createCommentVNode("", true),
      (!_ctx.isNewTask)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["task__hours", { alertEstimation: _ctx.alertEstimationHours || !_ctx.task.isEstimated }])
          }, [
            _withDirectives(_createElementVNode("input", {
              id: `estimatedHours_${_ctx.index}`,
              type: "text",
              class: "task__input custom-outline task__estimation",
              maxlength: "2",
              value: _ctx.estimation,
              readonly: _ctx.isReadonly,
              placeholder: "--",
              autocomplete: "off",
              onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleChanges($event.target as HTMLInputElement))),
              onKeypress: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onHoursValidate($event))),
              onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
            }, null, 40, _hoisted_11), [
              [_directive_focus, _ctx.isActive(`estimatedHours_${_ctx.index}`)]
            ])
          ], 2))
        : _createCommentVNode("", true),
      _createVNode(_component_AvatarSelect, {
        id: `owner_${_ctx.index}`,
        user: _ctx.task.owner,
        "onUpdate:user": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.task.owner) = $event)),
        userModifiers: { sync: true },
        class: _normalizeClass([{ task__owner_disable: !_ctx.taskNameLength }]),
        teamId: _ctx.teamId,
        focusable: false,
        dropdownPosition: _ctx.avatarPosition,
        customDarkBgColor: _ctx.customDarkBgColor,
        customLightThemeBgColor: _ctx.customLightThemeBgColor,
        isReadonly: _ctx.isReadonly,
        onSelected: _ctx.handleChanges,
        onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
      }, null, 8, ["id", "user", "class", "teamId", "dropdownPosition", "customDarkBgColor", "customLightThemeBgColor", "isReadonly", "onSelected"]),
      _createVNode(_component_DropdownTooltip, {
        class: _normalizeClass(["task__menu", [{ task__menu_disable: !_ctx.taskNameLength || _ctx.isReadonly }]]),
        subDropdownClass: "task__menu-sub",
        subMenuClass: "task__menu__item",
        iconSize: "md",
        placement: "bottom-end",
        placementSub: "left-start",
        iconSizeSub: "md",
        distanceSub: 16,
        menu: _ctx.moreOptions,
        disabledSub: _ctx.selectOption !== 'moveTo',
        tabIndex: -1,
        onDropdownSubMenu: _ctx.dropdownSubMenu,
        onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"]))
      }, {
        "tooltip-subContent": _withCtx(() => [
          _createVNode(_component_TaskMoveTo, {
            teamId: _ctx.teamId,
            onTaskMove: _ctx.moveTo
          }, null, 8, ["teamId", "onTaskMove"])
        ]),
        _: 1
      }, 8, ["class", "menu", "disabledSub", "onDropdownSubMenu"])
    ])), [
      [_directive_tooltip, {
        content: _ctx.task.getReadOnlyHint(_ctx.itemTeamType, _ctx.itemConfig),
        theme: 'info-tooltip',
        placement: 'top',
        popperClass: 'story__title__tooltip',
        disabled: !_ctx.task.readOnly
      }]
    ]),
    (_ctx.alertEstimationHours)
      ? (_openBlock(), _createBlock(_component_BaseCaption, {
          key: 0,
          size: "small",
          color: "serviceAlert-02",
          className: "task__validation"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Could this task be broken down into smaller tasks to be less than 24 hours in size? ")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 2))
}